import IndividualAadharDetails from './IndividualAadharDetails';

function AadharDetails() {
  return <IndividualAadharDetails />;
}

export default AadharDetails;
